export interface ILocale {
    [key: string]: {
        closeText: string;
        prevText: string;
        nextText: string;
        currentText: string;
        monthNames: string[];
        monthNamesShort: string[];
        dayNames: string[];
        dayNamesShort: string[];
        dayNamesMin: string[];
        weekHeader: string;
        dateFormat: string;
        momentDateFormat: string;
        firstDayOfWeek: number;
        isRTL: boolean;
        showMonthAfterYear: boolean;
        yearSuffix: string;
    };
}

export const LOCALE: ILocale = {
    fr: {
        closeText: "Fermer",
        prevText: "Précédent",
        nextText: "Suivant",
        currentText: "Aujourd'hui",
        monthNames: ["janvier", "février", "mars", "avril", "mai", "juin",
            "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
        monthNamesShort: ["janv.", "févr.", "mars", "avr.", "mai", "juin",
            "juil.", "août", "sept.", "oct.", "nov.", "déc."],
        dayNames: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
        dayNamesShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
        dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
        weekHeader: "Sem.",
        dateFormat: "dd/mm/yy",
        momentDateFormat: "DD/MM/YYYY",
        firstDayOfWeek: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    },
    en: {
        closeText: "Close",
        prevText: "Previous",
        nextText: "Next",
        currentText: "Today",
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday",
            "Saturday"],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        monthNames: ["January", "February", "March", "April", "May", "June", "July",
            "August", "September", "October", "November", "December"],
        monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"],
        weekHeader: "Week",
        dateFormat: "mm/dd/yy",
        momentDateFormat: "MM/DD/YYYY",
        firstDayOfWeek: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    },
    it: {
        closeText: "Chiudi",
        prevText: "Precedente",
        nextText: "Avanti",
        currentText: "Oggi",
        monthNames: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
            "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"],
        monthNamesShort: ["gen.", "feb.", "mar.", "apr.", "mag.", "giu.",
            "lug.", "ago.", "set.", "ott.", "nov.", "dic."],
        dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
        dayNamesShort: ["dom.", "lun.", "mar.", "mer.", "gio.", "ven.", "sab."],
        dayNamesMin: ["D", "L", "M", "M", "G", "V", "S"],
        weekHeader: "Settimane",
        dateFormat: "dd/mm/yy",
        momentDateFormat: "DD/MM/YYYY",
        firstDayOfWeek: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    },
    pt: {
        closeText: "Fechar",
        prevText: "Anterior",
        nextText: "Próximo",
        currentText: "Hoje",
        monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        monthNamesShort: ["Jan.", "Fev.", "Mar.", "Abr.", "Mai.", "Jun.",
            "Jul.", "Ago.", "Set.", "Out.", "Nov.", "Dez."],
        dayNames: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta", "Sexta-feira", "Sábado"],
        dayNamesShort: ["Dom.", "Seg.", "Ter.", "Qua.", "Qui.", "Sex.", "Sáb."],
        dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekHeader: "Semanas",
        dateFormat: "dd/mm/yy",
        momentDateFormat: "DD/MM/YY",
        firstDayOfWeek: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    },
    es: {
        closeText: "Cerrar",
        prevText: "Anterior",
        nextText: "Siguiente",
        currentText: "Hoy",
        dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes",
            "Sábado"],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mier", "Jue", "Vier", "Sab"],
        dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
        monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
            "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ag",
            "Sept", "Oct", "Nov", "Dic"],
        weekHeader: "Semana",
        dateFormat: "dd/mm/yy",
        momentDateFormat: "DD/MM/YYYY",
        firstDayOfWeek: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    }
};
